import React, { useEffect, useState, useMemo } from 'react'
import { Button, Card, CardBody, Container } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { Row, Col } from 'reactstrap'
import { MaterialReactTable } from 'material-react-table';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from '../../Components/Utils/Loader';
import { fetchAllPartner } from '../../slices/PartnerMangement/thunk'
import { MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { setEditSuccessMessage, setSuccessMessage } from '../../slices/toastMessage/action';
import { toast, ToastContainer } from 'react-toastify';
import { PAGE_TITLES } from '../Common/constants';
import { handleExportData } from '../Utils/ExportToCsv';
import { handleExportDataForPartner } from './Constants/HandleExportData';
import { useColumnSettings } from '../Utils/useColumnSettings';
import { getView } from '../../slices/View/thunk';
import { formatDateForDisplay, formatCellValue, formatPhoneNumber } from '../Utils/UtilityFunctions';
import { hasPermission } from '../Utils/UtilityFunctions';
function Partners() {
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();

    useEffect(() => {
        dispatch(fetchAllPartner(setLoading))
        dispatch(getView(setLoading));
    }, [dispatch])

    const PartnerData = useSelector((state) => state.Partner.partner)
    const rawPermissions = useSelector(
        (state) => state.permissions.permissionsMap
    );

    const permissionsMap = new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );
    const partnerPermission = hasPermission(permissionsMap, "partners", "partner")
    const viewPermission = hasPermission(permissionsMap, "miscellaneous", "view")

    const moment = require('moment');
    const formattedOrganizations = PartnerData.map(org => {
        if (org.createdAt) {
            const formattedDate = moment(org.createdAt).format('DD-MMM-YYYY');
            return { ...org, createdAt: formattedDate };
        }
        return org;
    });

    const organizationsWithMaidIds = [];
    PartnerData.forEach(organization => {
        const orgWithMaidId = {
            maidIds: []
        };
        if (organization.contactMedium) {
            organization.contactMedium.forEach(contact => {
                if (contact.characteristic && contact.characteristic.emailAddress) {
                    orgWithMaidId.maidIds.push(contact.characteristic.emailAddress);
                }
            });
        } else {
            orgWithMaidId.maidIds.push("-");
        }
        organizationsWithMaidIds.push(orgWithMaidId);
    });

    const organizationsWithPhoneNum = [];
    PartnerData.forEach(organization => {
        const orgWithPhoneNum = {
            PhoneNums: []
        };
        if (organization.contactMedium) {
            organization.contactMedium.forEach(contact => {
                if (contact.characteristic && contact.characteristic.phoneNumber) {
                    orgWithPhoneNum.PhoneNums.push(contact.characteristic.phoneNumber);
                }
            });
        } else {
            orgWithPhoneNum.PhoneNums.push("-");
        }
        organizationsWithPhoneNum.push(orgWithPhoneNum);
    });

    const navigateToView = async (row) => {
        const extractedId = row?.original?.id?.split('/').pop();
        let path = `/view-partner/${extractedId}`;
        navigate(path);
    };

    const navigateToCreate = () => {
        navigate('/create-partner')
    }

    const navigateToUpdate = async (row) => {
        const extractedId = row?.original?.id?.split('/').pop();
        let path = `/update-partner/${extractedId}`;
        navigate(path);
    };

    const extractedIds = PartnerData.map(item => item?.id?.split('/').pop());
    const showSuccessMessage = useSelector((state) => state.SuccessToast.showSuccessMessage)
    const showEditSuccessMessage = useSelector((state) => state.SuccessToast.showEditSuccessMessage)

    useEffect(() => {
        if (showSuccessMessage) {
            toast.success(`Partner Created Successfully`);
            dispatch(setSuccessMessage(false))
        }
        if (showEditSuccessMessage) {
            toast.success(`Partner Updated Successfully`);
            dispatch(setEditSuccessMessage(false))
        }
    }, [showSuccessMessage, dispatch]);

    const columns = useMemo(
        () => [
            {
                accessorFn: (PartnerData, index) => `${extractedIds[index]}`,
                header: 'Partner ID',
                id: 'partnerId',
                Cell: ({ cell }) => formatCellValue(cell.getValue())
            },
            {
                accessorKey: 'tradingName',
                header: 'Business Name',
                Cell: ({ cell }) => formatCellValue(cell.getValue())
            },
            {
                accessorKey: '@baseType',
                header: 'Type',
                Cell: ({ cell }) => formatCellValue(cell.getValue())
            },
            {
                accessorKey: 'Email',
                accessorFn: (PartnerData, index) => `${organizationsWithMaidIds[index].maidIds}`,
                header: 'Email',
                Cell: ({ cell }) => formatCellValue(cell.getValue())
            },
            {
                accessorKey: 'Phone',
                accessorFn: (PartnerData, index) => `${organizationsWithPhoneNum[index].PhoneNums}`,
                header: 'Phone',
                Cell: ({ cell }) => formatCellValue(formatPhoneNumber(`${cell.getValue()}`))
            },
            {
                accessorKey: 'Created On',
                accessorFn: (PartnerData, index) => `${formattedOrganizations[index].createdAt}`,
                header: 'Created On',
                Cell: ({ cell }) => formatCellValue(cell.getValue(), val => formatDateForDisplay(val))
            },
        ],
        [organizationsWithMaidIds],
    );

    const {
        settingsModalOpen,
        viewColumns,
        toggleSettingsModal,
        SettingsSidebar,
        CustomViewModal
    } = useColumnSettings('partner', columns);

    return (
        <React.Fragment>
            <div id='csms' className='page-content'>
                <Container fluid>
                    <BreadCrumb title={PAGE_TITLES.PARTNER_LIST} pageTitle={PAGE_TITLES.PARTNER} />
                    <Row>
                        <Col lg={12}>
                            <div className="listingjs-table " id="customerList">

                                <ToastContainer position='top-center' />
                                <CardBody>
                                    <Row className="mb-3 mt-1 table-responsive">
                                        {loading && (<Loader />)}
                                        {PartnerData ?
                                            <MaterialReactTable
                                                icons={{
                                                    DragHandleIcon: () => <i className="ri-drag-move-fill" />,
                                                }}

                                                renderTopToolbarCustomActions={({ table }) => (
                                                    <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100">
                                                        <h5 className="rv-page-title p-1">Partner List</h5>
                                                        <div className="d-flex align-items-center">
                                                            <div className="d-flex ">
                                                                {partnerPermission && partnerPermission?.has("export") &&
                                                                    <Button
                                                                        color="secondary"
                                                                        className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 me-2 w-md-auto text-nowrap"
                                                                        onClick={() => { handleExportDataForPartner(PartnerData) }}
                                                                    >
                                                                        <i className="ri-download-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                                                        <span className="px-2 ps-3 ms-2 me-1">Export</span>
                                                                    </Button>}
                                                                {partnerPermission && partnerPermission?.has('create') &&
                                                                    <Button
                                                                        color="secondary"
                                                                        className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 me-2 w-100 w-md-auto text-nowrap"

                                                                        onClick={navigateToCreate}
                                                                    // setIsEditMode(false);

                                                                    >
                                                                        <i className="ri-add-fill label-icon align-middle fs-16 me-1"></i>
                                                                        <span className="ps-2 ms-2 me-1"> Add Partner</span>
                                                                    </Button>
                                                                }


                                                            </div>
                                                            {viewPermission && viewPermission?.has("view") &&
                                                                <div color="secondary" className="btn-icon cursor-img" onClick={toggleSettingsModal}>
                                                                    <i className="ri-settings-2-line fs-4"></i>
                                                                </div>}
                                                        </div>
                                                    </div>
                                                )}
                                                columns={columns.filter((column) => viewColumns?.includes(column.accessorKey || column.header))}
                                                data={PartnerData}
                                                enableDensityToggle={false}
                                                enableColumnActions={true}

                                                displayColumnDefOptions={{
                                                    'mrt-row-actions': {
                                                        header: '',
                                                        enableHiding: true,
                                                        size: 52,
                                                        grow: true
                                                    },
                                                }}
                                                muiTableContainerProps={{
                                                    sx: {
                                                        border: '1px solid #e9ebec',
                                                    }
                                                }}
                                                defaultColumn={{
                                                    minSize: 10,
                                                    maxSize: 9001,
                                                    muiTableBodyCellProps: {
                                                        sx: {
                                                            fontFamily: "Inter,sans-serif"
                                                        }
                                                    },
                                                    muiTableHeadCellProps: {
                                                        sx: {
                                                            fontFamily: "Inter,sans-serif"
                                                        }
                                                    }
                                                }}
                                                initialState={{
                                                    columnVisibility: {
                                                        'partnerId': false,
                                                    },
                                                }}
                                                enableRowActions={partnerPermission && partnerPermission?.has('view')}
                                                renderRowActionMenuItems={({ closeMenu, row }) => [
                                                    partnerPermission && partnerPermission?.has('view') ? <MenuItem className='row-options'
                                                        key="edit"
                                                        onClick={() => {
                                                            navigateToView(row);
                                                        }}
                                                    >
                                                        <i className="ri-eye-line me-2"></i>
                                                        View
                                                    </MenuItem> : null,

                                                ]}
                                            />
                                            : null
                                        }
                                    </Row>
                                </CardBody>

                            </div>
                        </Col>
                        {CustomViewModal()}
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}
export default Partners;